import axios from 'axios';

const stripUselessPropsInNestedObj = (obj: Record<string, string>) => {
  delete obj['id'];
  return { ...obj };
};

const stripUselessPropsInRootObj = (
  obj: Record<string, string | Record<string, string>>,
  isExtended = false
) => {
  delete obj['id'];
  delete obj['published_at'];
  delete obj['created_at'];
  delete obj['updated_at'];

  if (isExtended) {
    delete obj['localizations'];
    delete obj['locale'];
  }

  return { ...obj };
};

const stripUselessKeysInTranslations = (
  obj: Record<string, string | Record<string, string>>,
  isExtended = false
) => {
  const strippedRoot = stripUselessPropsInRootObj(obj, isExtended);

  Object.keys(strippedRoot).forEach((k) => {
    if (typeof strippedRoot[k] === 'object' && strippedRoot[k]) {
      strippedRoot[k] = stripUselessPropsInNestedObj(
        strippedRoot[k] as Record<string, string>
      );
    }
  });

  return { ...strippedRoot };
};

export const downloadLocaleTranslations = async (
  url: string,
  locale: string
) => {
  const { data } = await axios.get(`${url}`, {
    params: {
      _locale: `${locale}`,
    },
  });
  return stripUselessKeysInTranslations(data, true);
};
